<div id="preview" class="w-100 h-100" *ngIf="show" (click)="close()">
  <i class="bi bi-x-lg close-icon"></i>
  <div class="preview-fitmade4u" *ngIf="previewSettings.app === 'fit-made4u'">
    <div class="position-relative">
      <img *ngIf="this.previewSettings.logo1" class="logo1" [src]="this.previewSettings.logo1">
      <img *ngIf="this.previewSettings.logo2" class="logo2" [src]="this.previewSettings.logo2">
    </div>
    <div class="logos-center">
      <div *ngIf="this.previewSettings.logoA || this.previewSettings.fitName" class="logoA-container">
        <img *ngIf="this.previewSettings.logoA" [src]="this.previewSettings.logoA" class="logoA">
        <span *ngIf="!this.previewSettings.logoA">{{this.previewSettings.fitName}}</span>
      </div>
      <div *ngIf="this.previewSettings.logoB || this.previewSettings.m4uName" class="logoB-container">
        <img *ngIf="this.previewSettings.logoB" [src]="this.previewSettings.logoB" class="logoB">
        <span *ngIf="!this.previewSettings.logoB">{{this.previewSettings.m4uName}}</span>
      </div>
    </div>
  </div>

  <div class="preview-depict" *ngIf="previewSettings.app === '360Depict'">
    <img src="../../../../assets/images/360DepictBackground.png" class="w-100 h-100 rounded-0">
    <div class="logoC-container">
      <img *ngIf="this.previewSettings.logoC" [src]="this.previewSettings.logoC" class="logoC">
      <span *ngIf="!this.previewSettings.logoC">{{this.previewSettings.depictName}}</span>
    </div>
  </div>
</div>
